import PropTypes from 'prop-types'
import NavigationLink from './navigation-link'
import NavbarListElement from './navbar-list-element'

export default function NavigationItem({
  title,
  type,
  action,
  active,
  badge,
  context,
}) {
  const isToolbar = context === 'toolbar'
  return (
    <NavbarListElement toolbar={isToolbar}>
      {type === 'link' && (
        <NavigationLink inToolbar={isToolbar} active={active} href={action}>
          {title}
        </NavigationLink>
      )}
      {type === 'modal' && (
        <NavigationLink
          inToolbar={isToolbar}
          active={active}
          data-toggle="modal"
          data-target={`#${action}`}
          href="#">
          {title}
        </NavigationLink>
      )}
      {/* {badge ? (
        <span className="tw-absolute tw-top-1 tw--right-2 tw-inline-block tw-bg-secondary tw-w-3 tw-h-3 tw-rounded-full tw-border tw-border-white" />
      ) : null} */}
      {badge ? (
        <span className="tw-relative tw--top-px tw-inline-block tw-bg-secondary tw-ml-1 tw-w-5 tw-h-4 tw-rounded tw-text-white tw-text-center tw-text-xs">
          {badge}
        </span>
      ) : null}
    </NavbarListElement>
  )
}

NavigationItem.propTypes = {
  title: PropTypes.string,
  type: PropTypes.oneOf(['link', 'modal', 'special-modal']),
  action: PropTypes.string,
  active: PropTypes.bool,
  badge: PropTypes.bool,
  context: PropTypes.string,
}
